<template>
  <div class="panel mb-3 shadow-lg">
    <div class="header mb-3">{{ $t("#TR-edit-group") }}</div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-xl-4 mb-3">
        <label> {{ $t("#TR-name") }}:</label>
        <b-form-input v-model="group['name']"></b-form-input>
      </div>
      <div class="col-12 col-lg-6 col-xl-4">
        <label> {{ $t("#TR-parent-group") }}:</label>
        <br>
        <b-button v-if="parentGroup"
                  block variant="success"
                  @click="openDishGroupSelectorModal">
          {{ parentGroup.name ? parentGroup.name : 'Main group' }}
        </b-button>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <button class="btn btn-success float-right"
                @click="onSave">
          <span class="mdi mdi-content-save"></span>
          <span class="d-none d-md-inline"> {{ $t("#TR-save") }}</span>
        </button>
        <button class="btn btn-danger float-right mr-3"
                @click="onCancel">
          <span class="mdi mdi-close"></span>
          <span class="d-none d-md-inline"> {{ $t("#TR-cancel") }}</span>
        </button>
      </div>
    </div>

    <dish-group-selector-modal
      ref="dishGroupSelectorModal"
      :only-parent="true"
      :current-dish-group="selectedDishGroup"
      @selectDishGroup="selectDishGroup">
    </dish-group-selector-modal>

    <div v-if="saveLoader" class="small-loader">
      <i class="mdi mdi-rotate-right mdi-spin"></i>
    </div>

  </div>
</template>

<script>
  import DishGroupSelectorModal from '@/views/WebEditor/Dishes/DishGroupSelectorModal';
  import { ApiDishGroup } from '@/services/api';
  import MSG from '@/services/notify';

  export default {
    name: 'EditGroup',
    components: {
      DishGroupSelectorModal
    },
    props: {
      selectedDishGroup: {
        type: Object,
        require: true,
        default: () => {
          return {};
        }
      }
    },

    data() {
      return {
        group: JSON.parse(JSON.stringify(this.selectedDishGroup)),
        parentGroup: {},
        saveLoader: false
      };
    },

    async created() {
      await this.getParent();
    },

    methods: {

      async onSave() {
        this.saveLoader = true;

        if (!this.group.name) {
          MSG.error(this.$t('#TR-enter-group-name'), this);
          this.saveLoader = false;

          return;
        }

        const options = {
          name: this.group.name,
          parent: this.parentGroup.sifr
        };

        if (!this.parentGroup.sifr) {
          options.parent = null;
        }

        const result = await ApiDishGroup.update(this.group.guid, options);

        if (result.error) {
          MSG.error(result.error, this);
          this.saveLoader = true;
        } else {
          this.saveLoader = false;
          MSG.success(this.$t('#TR-group-saved'), this);
          this.$emit('save', result.data);
        }
      },

      async getParent() {

        if (!this.group.parent) {
          return;
        }

        const result = await ApiDishGroup.get(this.group.parent);
        if (!result.error) {
          this.parentGroup = result.data;
        }
      },

      onCancel() {
        this.$emit('close');
      },

      selectDishGroup(group) {

        if (!group) {
          this.parentGroup = {
            sifr: null,
            name: 'Main Group'
          };
        } else {
          this.parentGroup = group;
        }
      },

      openDishGroupSelectorModal() {
        this.$refs.dishGroupSelectorModal.openDishGroupSelectorView();
      }
    }
  };
</script>

<style lang="stylus" scoped>

</style>
